import { cn } from 'lib/helpers/utility';
import { useIsShellHosted } from 'lib/context/ShellContext/ShellContext';

import Header from 'components/shared/Header/Header';
import HeaderViews from 'components/shared/AgTablePage/components/HeaderViews';

import ChromeInfo from './components/ChromeInfo';
import ChromeActions from './components/ChromeActions';

// `views` gets `{ variant, sizedByContainer, allLabel }` to spread into ViewTabs or a ToggleSwitch.
const PageHeader = ({
  title,
  subtitle,
  views,
  viewTabs,
  children,
  className,
  actionsClassName
}) => {
  const isHosted = useIsShellHosted();

  return (
    <Header
      title={title}
      subtitle={subtitle}
      titleAddon={<ChromeInfo />}
      compact
      wrap={isHosted}
      className={className}>
      {(views || viewTabs) && (
        <HeaderViews isHosted={isHosted} titled={!!title} views={views} {...viewTabs} />
      )}
      <div
        className={cn(
          'ml-auto flex max-w-full flex-wrap items-center justify-end gap-2 py-1',
          actionsClassName
        )}>
        {children}
        <ChromeActions />
      </div>
    </Header>
  );
};

export default PageHeader;
